import { render, staticRenderFns } from "./CertList.vue?vue&type=template&id=9333a344"
import script from "./CertList.vue?vue&type=script&lang=js"
export * from "./CertList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports